import React, { useEffect, useState, useCallback } from 'react';
import api from '../utils/api';
import { fmtTs } from './MeetingVideoModal';
import Icon from './Icon';

// "Toplantıdan Gelenler": Fireflies aksiyon maddeleri — görev ÖNERİSİ.
// Göreve Ekle → mevcut görev formu dolu açılır (onAccept). Yoksay → listeden düşer, geri alınabilir.

export default function MeetingSuggestions({ onAccept, onPlay, onCountChange, refreshKey }) {
  const [items, setItems] = useState([]);
  const [scope, setScope] = useState('mine');
  const [status, setStatus] = useState('open');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/meetings/action-items', { params: { scope, status } });
      setItems(r.data);
      if (scope === 'mine' && status === 'open' && onCountChange) onCountChange(r.data.length);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [scope, status, onCountChange]);

  useEffect(() => { load(); }, [load, refreshKey]);

  const act = async (id, action) => {
    try {
      await api.post(`/meetings/action-items/${id}/${action}`);
      setItems(list => list.filter(i => i.id !== id));
      if (scope === 'mine' && status === 'open' && onCountChange) onCountChange(items.length - 1);
    } catch (err) {
      alert(err.response?.data?.error || 'İşlem yapılamadı');
      load();
    }
  };

  const q = search.trim().toLocaleLowerCase('tr');
  const shown = items.filter(i => !q || [i.text, i.meeting_title, i.brand_name, i.assignee_name, i.assignee_user_name]
    .some(v => v && v.toLocaleLowerCase('tr').includes(q)));

  // Toplantıya göre grupla (liste zaten tarihe göre sıralı gelir)
  const groups = [];
  for (const i of shown) {
    let g = groups[groups.length - 1];
    if (!g || g.meeting_id !== i.meeting_id) {
      g = { meeting_id: i.meeting_id, title: i.meeting_title, date: i.meeting_date, brand: i.brand_name, items: [] };
      groups.push(g);
    }
    g.items.push(i);
  }

  const seg = (val, cur, set, label) => (
    <button type="button" onClick={() => set(val)} className={cur === val ? 'btn btn--selected' : 'btn btn--secondary'}
      style={{ padding: '4px 12px', fontSize: 13 }}>{label}</button>
  );

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 16 }}>
        {seg('mine', scope, setScope, 'Bana atananlar')}
        {seg('all', scope, setScope, 'Tümü')}
        <span style={{ width: 12 }} />
        {seg('open', status, setStatus, 'Bekleyen')}
        {seg('accepted', status, setStatus, 'Göreve çevrilen')}
        {seg('dismissed', status, setStatus, 'Yoksayılan')}
        <div className="search-bar" style={{ marginLeft: 'auto' }}>
          <span className="search-bar__icon"><Icon name="search" size={15} /></span>
          <input className="search-bar__input" placeholder="Madde / toplantı ara..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
      </div>

      {loading ? (
        <div className="page-loading">Yükleniyor...</div>
      ) : groups.length === 0 ? (
        <div className="card text-muted" style={{ textAlign: 'center', padding: 32 }}>
          {status === 'open' ? 'Bekleyen toplantı maddesi yok' : 'Kayıt yok'}
        </div>
      ) : groups.map(g => (
        <div key={g.meeting_id} className="card" style={{ marginBottom: 12, padding: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8, flexWrap: 'wrap' }}>
            <strong style={{ color: '#F2EFE6' }}>{g.title}</strong>
            {g.brand && <span className="badge" style={{ background: '#2A2D32', color: 'var(--text-soft)' }}>{g.brand}</span>}
            <span className="text-muted text-sm">
              {g.date && new Date(g.date).toLocaleString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
            </span>
            <button type="button" className="btn btn--secondary" style={{ padding: '2px 10px', fontSize: 12, marginLeft: 'auto' }}
              onClick={() => onPlay(g.meeting_id)}><Icon name="play" size={11} /> Kaydı İzle</button>
          </div>
          {g.items.map(i => (
            <div key={i.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderTop: '1px solid #17191C', fontSize: 14 }}>
              <button type="button" onClick={() => onPlay(i.meeting_id, i.ts_seconds)} title="Videoda bu ana git"
                style={{ background: 'none', border: 'none', color: '#D4FF3A', cursor: 'pointer', padding: 0, minWidth: 44, textAlign: 'left', fontVariantNumeric: 'tabular-nums' }}>
                {i.ts_seconds != null ? fmtTs(i.ts_seconds) : <Icon name="play" size={12} />}
              </button>
              <span style={{ flex: 1, color: '#E4E1D8' }}>
                {i.text}
                {i.auto_note && status === 'open' && (
                  <span className="text-muted" style={{ display: 'block', fontSize: 12, marginTop: 2 }}>Otomatik göreve çevrilmedi: {i.auto_note}</span>
                )}
              </span>
              <span className="text-muted text-sm" style={{ whiteSpace: 'nowrap' }}
                title={i.assignee_user_id ? `Fireflies: ${i.assignee_name}` : 'CRM kullanıcısıyla eşleşmedi'}>
                {i.assignee_user_name || (i.assignee_name ? `${i.assignee_name} ?` : 'atanmamış')}
              </span>
              {status === 'open' && (
                <>
                  <button type="button" className="btn btn--secondary" style={{ padding: '2px 10px', fontSize: 12, color: 'var(--accent)' }} onClick={() => onAccept(i)}>Göreve Ekle</button>
                  <button type="button" className="btn btn--secondary" style={{ padding: '2px 10px', fontSize: 12 }} onClick={() => act(i.id, 'dismiss')}>Yoksay</button>
                </>
              )}
              {status === 'dismissed' && (
                <button type="button" className="btn btn--secondary" style={{ padding: '2px 10px', fontSize: 12 }} onClick={() => act(i.id, 'restore')}>Geri Al</button>
              )}
              {status === 'accepted' && (
                <span className="text-muted text-sm" style={{ whiteSpace: 'nowrap' }}>
                  {i.auto_created ? <span title={i.auto_note || ''}>Otomatik görev</span> : (i.decided_by_name || '')}{i.task_id ? '' : ' (görev silinmiş)'}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
